import type { MetricData, ProductItem, RankItem } from '@contracts';

export function TableWidget({ data }: { data: MetricData }) {
  const rows = Array.isArray(data) ? (data as Array<RankItem | ProductItem>) : [];
  const money = (v: number) =>
    v.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

  return (
    <div className="h-full overflow-auto pr-1">
      {rows.map((row, i) => {
        const isRank = 'value' in row;
        const value = isRank ? (row as RankItem).value : (row as ProductItem).total;
        const sub = isRank ? `${(row as RankItem).orders} órd.` : `${(row as ProductItem).qty} u.`;
        return (
          <div
            key={i}
            className="flex items-center gap-2 border-b border-slate-50 py-1.5 last:border-0 hover:bg-slate-50/60"
          >
            <span
              className={`grid h-5 w-5 shrink-0 place-items-center rounded-md text-[10px] font-bold ${
                i === 0 ? 'bg-red-600 text-white' : 'bg-slate-100 text-slate-500'
              }`}
            >
              {i + 1}
            </span>
            <span className="min-w-0 flex-1 truncate text-sm text-slate-700">{row.name}</span>
            <div className="shrink-0 text-right">
              <p className="text-sm font-bold tabular-nums text-red-700">{money(value)}</p>
              <p className="text-[10px] text-slate-400">{sub}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
